const token = {
    Auth:localStorage.getItem("token"),
    "Content-Type":'multipart/form-data'
}
export default token;